import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/login/Login.vue";
import ForgotPassword from "./views/login/ForgotPassword.vue";
import store from "./store.js";

Vue.use(Router);

let router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/resetar-senha",
      name: "resetar-senha",
      component: ForgotPassword
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: false
      },
      children: [
        {
          name: "categories-list",
          path: "/categories/list",
          component: () => import("./views/categories/List.vue")
        },
        {
          name: "orders-list",
          path: "/orders/list/:status",
          props: true,
          component: () => import("./views/orders/ListStatus.vue")
        },
        {
          name: "products-list-all",
          path: "/products/list/todos",
          component: () => import("./views/products/ListAll.vue")
        },
        {
          name: "products-list",
          path: "/products/list/:tipo",
          props: true,
          component: () => import("./views/products/List.vue")
        },
        {
          name: "products-order",
          path: "/products/order/",
          props: true,
          component: () => import("./views/products/Order.vue")
        },
        {
          name: "prices-list",
          path: "/products/prices/list",
          props: true,
          component: () => import("./views/prices/List.vue")
        },
        {
          name: "banners-list",
          path: "/banners/list",
          props: true,
          component: () => import("./views/banners/List.vue")
        },
        {
          name: "drugstores-list",
          path: "/drugstores/list",
          component: () => import("./views/drugstores/List.vue")
        },
        {
          name: "users-list",
          path: "/users/list/:tipo",
          props: true,
          component: () => import("./views/users/List.vue")
        },
        {
          name: "import-price",
          path: "/import/price",
          props: true,
          component: () => import("./views/import/Price.vue")
        },
        {
          name: "mapa",
          path: "/mapa",
          component: () => import("./views/mapa/Mapa.vue")
        },
        {
          name: "showcase",
          path: "/showcase",
          component: () => import("./views/showcase/ShowCase.vue")
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.loggedIn) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }
});

export default router;
